<div
  #overlayContainer
  class="overlay-container"
  [class.active-session]="connectionStatus === diagnosticsConnectionStatus.ACTIVE"
  [class.loading-session]="connectionStatus === diagnosticsConnectionStatus.LOADING"
  [class.failed-session]="connectionStatus === diagnosticsConnectionStatus.FAILED"
>
  <div class="overlay-header flex flex-row justify-between items-center lt-md:items-start">
    <div class="flex flex-row flex-wrap gap-[12px] justify-start items-center">
      <h1>
        {{ '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.TITLE' | translate }}
      </h1>
      <app-diagnostics-connection-status
        [attr.data-at-connection-status]="connectionStatus"
        [connectionStatus]="connectionStatus"
        [isDiagnosticsAvailable]="isDiagnosticsAvailable"
        [installationPackage]="installationPackage"
        [devicePlatform]="devicePlatform"
        [gatewaySerial]="gatewaySerial"
      ></app-diagnostics-connection-status>
    </div>
    <app-diagnostics-close-button
      data-at-close-diagnostic-session
      [installationId]="installationId"
      [gatewaySerial]="gatewaySerial"
    ></app-diagnostics-close-button>
  </div>
  <!-- TODO for now, we block re-selection if session is active but it must be possible in the future -->
  <app-devices-list
    data-at-cascade-installation-list
    *ngIf="installationDetailsStore.isSelectedGatewayACascade$ | async"
    [devicesList$]="devicesStore.devicesOfV2Cascade$"
    [disabled]="
      connectionStatus === diagnosticsConnectionStatus.LOADING ||
      connectionStatus === diagnosticsConnectionStatus.ACTIVE
    "
  ></app-devices-list>

  <app-diagnostics-tabs
    *ngIf="connectionStatus === diagnosticsConnectionStatus.ACTIVE"
    data-at-diagnostic-tabs-menu
    [activeDiagnosticOverlay]="activeDiagnosticOverlay"
    [installationId]="installationId"
    [gatewaySerial]="gatewaySerial"
    [deviceSerial]="boilerSerial"
  ></app-diagnostics-tabs>

  <div class="overlay-body flex flex-col gap-[30px]">
    <app-diagnostics-connection-box
      *ngIf="connectionStatus !== diagnosticsConnectionStatus.ACTIVE && isDiagnosticsAvailable"
      [gatewaySerial]="gatewaySerial"
      [connectionStatus]="connectionStatus"
      [isDemo]="isDemo"
    ></app-diagnostics-connection-box>
    <app-locked-system-error-banner
      *ngIf="
        activeDiagnosticOverlay === diagnosticsOverlayTypeEnum.GuidedTroubleshooting &&
          activeErrorsStore.isLockedSystemError(gatewaySerial) | async
      "
    >
    </app-locked-system-error-banner>
    <ng-template
      [ngIf]="
        activeDiagnosticOverlay === diagnosticsOverlayTypeEnum.GuidedTroubleshooting &&
        !(activeErrorsStore.hasAnyActiveErrorDetails$ | async)
      "
    >
      <app-no-gts-data-box></app-no-gts-data-box>
    </ng-template>

    <ng-container *appHideForRsaUser>
      <ng-template
        [ngIf]="remoteConfigStore.hasAccessToProPlusFeaturesByVkOrg$ | async"
        [ngIfElse]="showFeaturesNotAvailableBox"
      >
        <app-upgrade-package-box
          *ngIf="installationPackage === bookingPlans.Basic && devicePlatform === platform.E3"
          [boilerSerial]="boilerSerial"
        ></app-upgrade-package-box>
      </ng-template>
      <ng-template #showFeaturesNotAvailableBox>
        <app-features-not-available-box
          *ngIf="activeDiagnosticOverlay !== diagnosticsOverlayTypeEnum.GuidedTroubleshooting"
        ></app-features-not-available-box>
      </ng-template>
    </ng-container>

    <app-legacy-device-box *ngIf="devicePlatform === platform.Legacy"></app-legacy-device-box>

    <ng-container *appShowForRsaUser>
      <app-no-permission-box
        *ngIf="!isDiagnosticsAvailable && devicePlatform === platform.E3"
      ></app-no-permission-box>
    </ng-container>

    <ng-container [ngSwitch]="activeDiagnosticOverlay">
      <ng-container *ngSwitchCase="diagnosticsOverlayTypeEnum.DiagnosisBackupAndRestore">
        <app-information-popup
          [page]="InformationPopupPage.BackupAndRestore"
        ></app-information-popup>
        <app-backup></app-backup>
      </ng-container>
      <ng-container *ngSwitchCase="diagnosticsOverlayTypeEnum.ExtendedParameter">
        <app-extended-parameters></app-extended-parameters>
      </ng-container>
      <app-guided-troubleshooting
        *ngSwitchCase="diagnosticsOverlayTypeEnum.GuidedTroubleshooting"
      ></app-guided-troubleshooting>
      <ng-container *ngSwitchCase="diagnosticsOverlayTypeEnum.HydraulicSchematic">
        <app-information-popup
          [page]="InformationPopupPage.HydraulicSchemes"
        ></app-information-popup>
        <app-hydraulic-schemes
          *ngIf="remoteDiagnosticsStore.isActiveSessionAvailable(gatewaySerial) | async"
        ></app-hydraulic-schemes>
      </ng-container>
      <ng-container *ngSwitchCase="diagnosticsOverlayTypeEnum.DiagnosisSnapshots">
        <app-information-popup [page]="InformationPopupPage.Snapshot"></app-information-popup>
        <app-snapshot
          *ngIf="installationDetailsStore.isSnapshotMenuItemVisible(gatewaySerial) | async"
        ></app-snapshot>
      </ng-container>
    </ng-container>
  </div>
  <app-diagnostics-sticky-chart-panel
    *ngIf="
      connectionStatus === diagnosticsConnectionStatus.ACTIVE &&
      !(remoteDiagnosticsStore.isParameterListEmpty(gatewaySerial) | async) &&
      activeDiagnosticOverlay === diagnosticsOverlayTypeEnum.ExtendedParameter
    "
  ></app-diagnostics-sticky-chart-panel>
</div>
